import { render, staticRenderFns } from "./AppDetailPane.vue?vue&type=template&id=061e0ca8&"
import script from "./AppDetailPane.vue?vue&type=script&lang=js&"
export * from "./AppDetailPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports